import { render } from "./Guideline-edit.vue?vue&type=template&id=1710cf8a"
import script from "./Guideline-edit.vue?vue&type=script&lang=js"
export * from "./Guideline-edit.vue?vue&type=script&lang=js"

import "./Guideline-edit.vue?vue&type=style&index=0&id=1710cf8a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__